import { useRef, useEffect } from 'react';
import type { StrokeInput } from '@twitch-draw/shared';
import { renderStroke } from '../canvas/renderer';

interface FrameThumbnailProps {
  strokes: StrokeInput[];
  width: number;
  height: number;
}

export function FrameThumbnail({ strokes, width, height }: FrameThumbnailProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const dpr = window.devicePixelRatio || 1;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, width, height);

    const scale = Math.min(width / 1920, height / 1080);
    strokes.forEach((stroke) =>
      renderStroke(ctx, stroke.points, stroke.color, Math.max(0.5, stroke.width * scale), width, height),
    );
  }, [strokes, width, height]);

  return (
    <canvas
      ref={canvasRef}
      style={{ width, height }}
      className="frame-thumbnail__canvas"
    />
  );
}
